"use client";
import { useState } from "react";
import PropTypes from "prop-types";
import IconArrow from "assets/svg/bold_up_arrow.svg";
import Button from "components/common/button";
import { LazyImage } from "components/common/lazy-image/LazyImage";

import { phoneFormatter } from "helpers/phone-formatter";

import styles from "./styles.module.css";

const CampanyInfo = ({ data }) => {
  const { website, phoneNumber, showPhone, address, logo, name } = data?.detailData?.[0]?.company || {};
  const [isShowPhone, setIsShowPhone] = useState(false);
  const handleShowPhoneButton = (e) => {
    e.preventDefault();
    setIsShowPhone(true);
  };

  return (
    <div className={styles.wrapper}>
      <LazyImage className={styles.logo} src={logo} alt={name} />
      <h2 className={styles.title}>{name}</h2>
      <p className={styles.address}>{address} </p>
      <div className={styles.phoneWrapper}>
        {showPhone &&
          (isShowPhone ? (
            <Button size="M" href={`tel:${phoneNumber}`}>
              {phoneFormatter(phoneNumber)}
            </Button>
          ) : (
            <Button size="M" onClick={(e) => handleShowPhoneButton(e)}>
              Telefona Bak
            </Button>
          ))}
        {website && (
          <a href={website} target="_blank" rel="noreferrer">
            <span className={styles.website}>
              Web Sitesi <IconArrow />
            </span>
          </a>
        )}
      </div>
    </div>
  );
};

CampanyInfo.propTypes = {
  data: PropTypes.object,
};
export default CampanyInfo;
